import { render, staticRenderFns } from "./CPLogin.vue?vue&type=template&id=dd9050b0&scoped=true&"
import script from "./CPLogin.vue?vue&type=script&lang=ts&"
export * from "./CPLogin.vue?vue&type=script&lang=ts&"
import style0 from "./CPLogin.vue?vue&type=style&index=0&id=dd9050b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd9050b0",
  null
  
)

export default component.exports